export enum CalloutSlugs {
  backgroundCheck = 'search-badge-callout',
  emptyResults = 'empty-results-callout',
}

export type EmptyResultsCallout = {
  position: number;
  data: {
    title: string;
    subtitle?: string;
  };
  slug: CalloutSlugs.emptyResults;
};

export type BackgroundCheckCalloutData = {
  title: string;
  badgeSlug: string;
  imageUrl: string;
  backgroundColor: string;
  highlightedTitleText: string;
  dialogData: {
    title: string;
    ctaText: string;
    items: Array<{
      title: string;
      description: string;
      imageUrl: string;
      ctaText: string;
      action: string;
    }>;
  };
};

export type BackgroundCheckCallout = {
  position: number;
  slug: CalloutSlugs.backgroundCheck;
  data: BackgroundCheckCalloutData;
};

export type Callout = EmptyResultsCallout | BackgroundCheckCallout;
